<template>
  <!-- <div class="container align-items-start text-start mt-4">
    <div id="firstStep" v-if="firstStepContainer" style="opacity: 1">
      <h2 style="font-size: 40px">Create new account</h2>
      <form>
        <div class="row">
          <div class="col-sm-12 col-md-6 mt-3 padding-container">
            <input
              type="text"
              placeholder="first name"
              v-model="firstname"
              autocomplete="off"
              ref="firstNameInput"
              required
            />
            <span
              class="error-text"
              v-if="!validationStatus && v$.firstname.$error"
              >Please enter your first name.</span
            >
          </div>
          <div class="col-sm-12 col-md-6 mt-3 padding-container">
            <input
              type="text"
              placeholder="last name"
              v-model="lastname"
              autocomplete="off"
              ref="lastNameInput"
              required
            />
            <span
              class="error-text"
              v-if="!validationStatus && v$.lastname.$error"
              >Please enter your last name.</span
            >
          </div>
          <div class="col-12 mt-3 padding-container">
            <input
              type="text"
              placeholder="email address"
              v-model="email"
              autocomplete="off"
              ref="emailInput"
              required
            />
            <span
              class="error-text"
              v-if="!validationStatus && !v$.email.required.$response"
              >Please enter your email.</span
            >
            <span
              class="error-text"
              v-else-if="!validationStatus && !v$.email.email.$response"
              >Please enter correct email format.</span
            >
          </div>
          <div class="col-12 mt-3 padding-container">
            <input
              type="password"
              @input="checkPassword"
              placeholder="password"
              v-model="password"
              autocomplete="off"
              ref="passwordInput"
              required
            />
            <span
              class="error-text"
              v-if="!validationStatus && !v$.password.required.$response"
              >Please enter your password.</span
            >
            <span
              class="error-text"
              v-else-if="!validationStatus && !valid_password"
              >Please enter correct password format.</span
            >
          </div>
          <div class="col-12 mt-3 padding-container">
            <input
              type="password"
              @input="checkConfirmPassword"
              placeholder="confirm password"
              v-model="confirmPassword"
              autocomplete="off"
              ref="confirmPasswordInput"
              required
            />
            <span
              class="error-text"
              v-if="!validationStatus && !v$.confirmPassword.required.$response"
              >Please enter your confirm password.</span
            >
            <span
              class="error-text"
              v-else-if="
                !validationStatus &&
                !v$.confirmPassword.sameAsPassword.$response
              "
              >Please enter correct password confirmation.</span
            >
          </div>
          <div class="mt-3">
            <div class="row mb-4 text-start" style="font-size: 0.8rem">
              <span
                v-bind:class="{ is_valid: contains_eight_characters }"
                class="col-6 py-2"
              >
                <img
                  v-if="contains_eight_characters"
                  src="@/assets/register/checkmark.svg"
                  width="14px"
                  alt="check"
                />
                <img
                  v-else
                  src="@/assets/register/checkemp.svg"
                  width="14px"
                  alt="check"
                />
                8 Characters
              </span>
              <span
                v-bind:class="{ is_valid: contains_number }"
                class="col-6 py-2"
              >
                <img
                  v-if="contains_number"
                  src="@/assets/register/checkmark.svg"
                  width="14px"
                  alt="check"
                />
                <img
                  v-else
                  src="@/assets/register/checkemp.svg"
                  width="14px"
                  alt="check"
                />
                Contains Number
              </span>
              <span
                v-bind:class="{ is_valid: contains_uppercase }"
                class="col-6 py-2"
              >
                <img
                  v-if="contains_uppercase"
                  src="@/assets/register/checkmark.svg"
                  width="14px"
                  alt="check"
                />
                <img
                  v-else
                  src="@/assets/register/checkemp.svg"
                  width="14px"
                  alt="check"
                />
                Contains Uppercase
              </span>
              <span
                v-bind:class="{ is_valid: contains_lowercase }"
                class="col-6 py-2"
              >
                <img
                  v-if="contains_lowercase"
                  src="@/assets/register/checkmark.svg"
                  width="14px"
                  alt="check"
                />
                <img
                  v-else
                  src="@/assets/register/checkemp.svg"
                  width="14px"
                  alt="check"
                />
                Contains Lowercase
              </span>
              <span
                v-bind:class="{ is_valid: contains_special_character }"
                class="col-6 py-2"
              >
                <img
                  v-if="contains_special_character"
                  src="@/assets/register/checkmark.svg"
                  width="14px"
                  alt="check"
                />
                <img
                  v-else
                  src="@/assets/register/checkemp.svg"
                  width="14px"
                  alt="check"
                />
                Contains Special Character
              </span>
              <span
                v-bind:class="{ is_valid: confirm_password }"
                class="col-6 py-2"
              >
                <img
                  v-if="confirm_password"
                  src="@/assets/register/checkmark.svg"
                  width="14px"
                  alt="check"
                />
                <img
                  v-else
                  src="@/assets/register/checkemp.svg"
                  width="14px"
                  alt="check"
                />
                Confirm Password
              </span>
            </div>
          </div>
        </div>
        <input style="width: 20px" type="checkbox" v-model="agree" />
        <span>
          I agree to the
          <a @click="termModalClick()" style="color: #2867eb; cursor: pointer">
            Terms and Conditions,
          </a>
          and
          <a @click="privacyClick()" style="color: #2867eb; cursor: pointer">
            Privacy Policy
          </a>
        </span>
        <div>
          <img v-if="errVisible" src="@/assets/register/vector.svg" />
          <span v-if="errVisible" style="color: red" class="errMsg">
            {{ errMsg }}
          </span>
        </div>
      </form>
      <button
        class="btn btn-start mt-3 mb-1 w-100"
        style="background-color: #1db954 !important"
        @click="checkFirstStep"
        :disabled="!agree"
      >
        Sign up
      </button>
      <span style="color: #abb6bb">Already have and account?</span>
      <span
        style="color: #ff8500; cursor: pointer; font-weight: bold"
        @click="signin"
      >
        Login</span
      >
    </div>
    <div v-if="step2Status" style="opacity: 1">
      <h2 style="font-size: 40px">Create new account</h2>
      <form>
        <div class="row">
          <div class="col-sm-12 mt-3">
            <label class="fw-bold mb-1 label-text"
              >What industry are you in ?
              <span class="error-text">*</span></label
            >
            <select
              v-model="industry"
              class="form-select"
              ref="industryInput"
              required
            >
              <option
                v-for="(ind, index) in industry_list"
                :key="index"
                :value="ind"
              >
                {{ ind }}
              </option>
            </select>
            <span
              class="error-text"
              v-if="!validationStatus && v$.industry.$error"
              >Please enter your industry.</span
            >
          </div>
          <div class="col-12 mt-3">
            <label class="fw-bold mb-1 label-text"
              >What is your job role ? <span class="error-text">*</span></label
            >
            <select
              v-model="job_role"
              class="form-select"
              ref="jobRoleInput"
              required
            >
              <option
                v-for="(job, index) in pos_list"
                :key="index"
                :value="job"
              >
                {{ job }}
              </option>
            </select>
            <span
              class="error-text"
              v-if="!validationStatus && v$.job_role.$error"
              >Please enter your job role.</span
            >
          </div>
          <div class="col-12 mt-3">
            <label class="fw-bold mb-1 label-text"
              >Phone number <span class="error-text">*</span></label
            >
            <vue-phone-number-input
              color="dodgerblue"
              v-model="phone_number"
              :dark="dark"
              :disabled="disabled"
              :ignored-countries="countriesIgnored"
              :preferred-countries="countriesList"
              :loader="hasLoaderActive"
              clearable
              :error="hasErrorActive"
              class="mb-2"
              ref="phoneNuberInput"
              required
            />
            <span
              class="error-text"
              v-if="!validationStatus && v$.phone_number.$error"
              >Please enter your phone number.</span
            >
          </div>
          <div class="col-12 mt-3">
            <label class="fw-bold mb-1 label-text"
              >Company name <span class="error-text">*</span></label
            >
            <input
              class="form-control"
              type="text"
              placeholder="company name"
              v-model="company_name"
              autocomplete="off"
              ref="companyNameINput"
              required
            />
            <span
              class="error-text"
              v-if="!validationStatus && v$.company_name.$error"
              >Please enter your company name.</span
            >
          </div>
          <div class="col-12 mt-3">
            <label class="fw-bold mb-1 label-text">Company website </label>
            <input
              class="form-control"
              type="text"
              placeholder="company website"
              v-model="company_website"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="mt-3">
          <img v-if="errVisible" src="@/assets/register/vector.svg" />
          <span v-if="errVisible" style="color: red" class="errMsg">
            {{ errMsg }}
          </span>
        </div>
        <button
          class="btn btn-start mt-3 mb-1"
          :style="{ width: '100%' }"
          @click="saveRegister"
        >
          Get started
        </button>
      </form>
    </div>
    <div class="row" v-if="stepSendEmail">
      <div class="col-12">
        <h2 style="font-size: 40px" :class="{ 'show-final': stepSendEmail }">
          Check your email <br />
        </h2>
      </div>
      <div class="col-12">
        <span style="color: #51646b" :class="{ 'show-final': stepSendEmail }">
          We've sent an email to <span class="fw-bold"> {{ email }} </span>
          <br />
          Click the link in the email to confirm your address and activate our
          account <br />
        </span>
      </div>
      <div class="col-12">
        <span
          :class="{ 'show-final': stepSendEmail }"
          style="color: #ff8500; cursor: pointer"
          @click="resendEmail"
          >Resend your verification email
        </span>
      </div>
    </div>
    <ModalTermAndCondition />
    <ModalPrivacy />
  </div> -->
  <div class="">
    <div class="container p-0">
      <div class="row justify-content-center align-items-center bg-form p-2"
        style="height: 100vh !important;overflow: auto;">
        <div class="col-12 text-start pt-5">
          <div class="d-flex align-items-center">
            <div class="w-100">
              <div class="mb-3" style="height: 55px;">
                <img src="@/assets/navBarLogo.png" alt="" height="100%">
              </div>
              <div class="">
                <div class="mb-3">
                  <span class="text-herder-create-acount">Create your account</span>
                </div>
                <div class="box p-3">
                  <div class="row">
                    <div class="col-12 col-md-6 padding-container mb-3">
                      <label for="firstname" class="label-text">Name</label>
                      <input v-model="firstname" class="form-control" type="text" placeholder="name" />
                      <span v-if="validationStatus == false &&
                        v$.firstname.$error
                        " class="error-text">
                        Please enter your name
                      </span>
                    </div>
                    <div class="col-12 col-md-6 padding-container mb-3">
                      <label for="lastname" class="label-text">Last name</label>
                      <input v-model="lastname" class="form-control" type="text" placeholder="last name" />
                      <span v-if="validationStatus == false &&
                        v$.lastname.$error
                        " class="error-text">
                        Please enter your last name
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-12 padding-container mb-3">
                      <label for="company" class="label-text">Company name</label>
                      <input v-model="company" class="form-control" type="text" placeholder="company name" />
                      <span v-if="validationStatus == false &&
                        v$.company.$error
                        " class="error-text">
                        Please enter your company name
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 padding-container mb-3">
                      <label for="email" class="label-text">Email address</label>
                      <input v-model="email" ref="emailInput" class="form-control" type="text"
                        placeholder="email address" />
                      <span class="error-text" v-if="!validationStatus && !v$.email.required.$response">Please enter your
                        email</span>
                      <span class="error-text" v-else-if="!validationStatus && !v$.email.email.$response">Please Enter
                        correct email format</span>
                      <span class="error-text" v-else-if="errMsg">{{ errMsg }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6 padding-container mb-3">
                      <label for="" class="label-text">Password</label>
                      <div class="form-group mb-0">
                        <input v-model="password" class="form-control" :type="!is_show_password ? 'password' : 'text'"
                          placeholder="password" style="height: 38px;" @input="checkPassword" />
                        <svg v-if="is_show_password" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                          fill="currentColor" class="bi bi-eye me-2 cursor-pointer" style="
                    float: right;
                    margin-top: -30px;
                    position: relative;
                    z-index: 2;
                  " viewBox="0 0 16 16" @click="is_show_password = !is_show_password">
                          <path
                            d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                          <path
                            d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                        </svg>
                        <svg v-if="!is_show_password" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                          fill="currentColor" class="bi bi-eye-slash me-2 cursor-pointer" style="
                    float: right;
                    margin-top: -30px;
                    position: relative;
                    z-index: 2;
                  " viewBox="0 0 16 16" @click="is_show_password = !is_show_password">
                          <path
                            d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                          <path
                            d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                          <path
                            d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                        </svg>
                      </div>

                      <span v-if="validationStatus == false && v$.password.$error
                        " class="error-text">
                        Please enter your password
                      </span>
                      <div v-show="!contains_text && oninput_password && !v$.password.$error" class="error-text">Password
                        must contain at least 1 letter.</div>
                      <div v-show="!contains_eight_characters && oninput_password && !v$.password.$error"
                        class="error-text">The password has to contain at least 8 characters.</div>
                    </div>
                    <div class="col-12 col-md-6 padding-container mb-3">
                      <label for="company name" class="label-text">Confirm Password</label>
                      <div class="form-group mb-0">
                        <input v-model="confirmPassword" class="form-control" style="height: 38px;"
                          :type="!is_show_confirm_password ? 'password' : 'text'" placeholder="confirm password" />
                        <svg v-if="is_show_confirm_password" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                          fill="currentColor" class="bi bi-eye me-2 cursor-pointer" style="
                    float: right;
                    margin-top: -30px;
                    position: relative;
                    z-index: 2;
                  " viewBox="0 0 16 16" @click="is_show_confirm_password = !is_show_confirm_password">
                          <path
                            d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                          <path
                            d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                        </svg>
                        <svg v-if="!is_show_confirm_password" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                          fill="currentColor" class="bi bi-eye-slash me-2 cursor-pointer" style="
                    float: right;
                    margin-top: -30px;
                    position: relative;
                    z-index: 2;
                  " viewBox="0 0 16 16" @click="is_show_confirm_password = !is_show_confirm_password">
                          <path
                            d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                          <path
                            d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                          <path
                            d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                        </svg>
                      </div>
                      <span v-if="validationStatus == false && v$.confirmPassword.$error
                        " class="error-text">
                        Please confirm password
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-12 padding-container mb-3">
                      <label for="code" class="label-text">Registration code</label>
                      <input v-model="code" ref="codeInput" class="form-control" type="text"
                        placeholder="registration code" />
                      <span v-if="validationStatus == false &&
                        v$.code.$error
                        " class="error-text">
                        Please enter the correct code
                      </span>
                      <span v-else-if="err_registercode" class="error-text">{{ err_registercode }}</span>
                    </div>
                  </div>
                  <div class="mt-3">
                    <input type="checkbox" class="form-check-input" v-model="confirm_agree" @change="updateChecbox()"
                      name="" id="">
                    <span class="text-check-box text-center ms-3">By continuing, you agree to our &nbsp;<u
                        @click="termModalClick" class="underline cursor-pointer"> Terms & Conditions </u>&nbsp; and
                      acknowledge our&nbsp;
                      <u class="cursor-pointer underline" @click="privacyClick"> Privacy Policy </u>
                    </span>
                  </div>
                  <div class="mt-3">
                    <input type="checkbox" class="form-check-input" v-model="confirm_receive_update"
                      @change="updateChecbox()">
                    <span class="text-check-box ms-3">I agree to receive updates and exclusive offers from Carbonwize. I
                      can opt out at any time</span>
                  </div>
                  <!-- <div class="d-flex justify-content-between align-items-center mt-3">
                  <span class="me-3"> {{ $t("TXT_ALREADY_HAVE_AND_ACCOUNT") }} <router-link to="/" class="tag-blue-color">{{ $t("TXT_LOGIN") }}</router-link></span>
                  <button class="btn btn-submit-demo" @click="checkFirstStep()" :disabled="!register_status">
                    {{ $t("TXT_REGISTER") }}
                  </button>
                </div> -->
                  <button v-if="!loading" class="btn button-green w-100 mt-3" :disabled="!register_status"
                    style="height: 90%" @click="checkRegister">
                    Create account
                  </button>
                  <div class="d-flex justify-content-center my-2" style="color: #51646b">or</div>
                  <router-link to="/" class="btn button-outline-green w-100 mb-3"
                    style="height: 90%;font-weight: 500;color: #1DB954; border-color: #1DB954;">Log in</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-12 col-lg-5 p-0">
          <img src="@/assets/img-right-form.png" class="mw-100" alt="" />
        </div> -->
      </div>
    </div>
    <ModalTermAndCondition />
    <ModalPrivacy />
  </div>
</template>
<script>
import axios from "axios";
// import LoadingVue from "./LoadingMask.vue";
import ModalTermAndCondition from "@/components/Modal/ModalTermAndCondition";
import ModalPrivacy from "@/components/Modal/ModalPrivacy.vue";
import { apiURL } from "@/configs/serverConfig";
import Position from "@/assets/position.json";
import Industry from "@/assets/industry.json";
// import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { useVuelidate } from "@vuelidate/core";
import { required, email, sameAs } from "@vuelidate/validators";

export default {
  components: { ModalTermAndCondition, ModalPrivacy },
  setup: () => ({ v$: useVuelidate() }),
  data: () => {
    return {
      password: "",
      confirmPassword: "",
      password_length: 0,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_lowercase: false,
      contains_special_character: false,
      confirm_password: false,
      valid_password: false,
      position: 0,
      inputLabel: "",
      inputType: "text",
      inputValue: "",
      firstStepContainer: false,
      showContainer: false,
      showFinal: false,
      topLabel: "",
      username: "",
      firstname: "",
      lastname: "",
      email: "",
      code: "",
      progress: "0%",
      token: "",
      loading: false,
      googleSignInParams: {
        client_id:
          "835665954617-r2fp90v0n8qp0l0l45kocgopk3vse262.apps.googleusercontent.com",
      },
      errVisible: false,
      errMsg: "",
      pattern: /.+/,
      emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      registerSteps: [],
      agree: false,
      step2Status: false,
      stepSendEmail: false,
      industry: "",
      job_role: "",
      company: "",
      company_size: "",
      company_website: "",
      phone_number: "",
      pos_list: Position.position,
      industry_list: Industry.industry,
      defaultCountry: "TH",
      countriesList: [],
      countriesIgnored: [],
      dark: false,
      disabled: false,
      hasLoaderActive: false,
      hasErrorActive: false,
      validationStatus: true,
      confirm_receive_update: false,
      confirm_agree: false,
      register_status: false,
      is_show_password: false,
      is_show_confirm_password: false,
      oninput_password: false,
      err_registercode: "",
      contains_text: false,
    };
  },
  validations() {
    return {
      firstname: { required },
      lastname: { required },
      password: { required },
      confirmPassword: { required, sameAsPassword: sameAs(this.password) },
      email: { required, email },
      company: { required },
      code: { required }
    };
  },
  // pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/  email pattern
  methods: {
    updateChecbox() {
      if (this.confirm_agree && this.confirm_receive_update) {
        this.register_status = true
      } else {
        this.register_status = false
      }
    },
    async checkRegister() {
      let isValidate = await this.v$.$validate();
      if (isValidate && this.valid_password) {
        axios
          .get(`${apiURL}/guest/exist_email?email=` + this.email)
          .then((response) => {
            console.log(response);
            if (response.data.code == 200) {
              this.errMsg = ""
              this.save();
            }
          })
          .catch((err) => {
            if (err.response.data.code == 1004) {
              this.errMsg = err.response.data.message;
              this.$refs.emailInput.focus();
            }
            err.response.data.message;
          });
      } else {
        this.validationStatus = false;
      }
    },
    async save() {
      const _data = {
        first_name: this.firstname,
        last_name: this.lastname,
        email: this.email,
        password: this.password,
        company_name: this.company,
        register_code: this.code,
        device: "mobile"
      };
      axios.post(`${apiURL}/guest/register`, _data).then((response) => {
        if (response) {
          this.err_registercode = ""
          this.$toast.success("Success");
          // this.token = await response.data.access_token;
          this.$router.push('/');
          // await this.getMainCompany();
        }
      }).catch((err) => {
        err.response.data.message;
        if (err.response.data.code == 1095) {
          this.err_registercode = err.response.data.message;
          // this.errVisible = true;
          this.$refs.codeInput.focus();
        }
      });
    },
    async saveRegister(e) {
      e.preventDefault();
      // if (!this.pattern.test(this.industry)) {
      //   this.errMsg = "Please Enter Industry";
      //   this.errVisible = true;
      //   // this.$refs.industryInput.focus();
      //   // this.$refs.firstNameInput.style.border = '1px solid #d93f38';
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else if (!this.pattern.test(this.job_role)) {
      //   this.errMsg = "Please Enter Job Role";
      //   this.errVisible = true;
      //   // this.$refs.jobRoleInput.focus();
      //   // this.$refs.firstNameInput.style.border = '1px solid #d93f38';
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else if (!this.phone_number) {
      //   this.errMsg = "Please Enter Phone Number";
      //   this.errVisible = true;
      //   this.$refs.phoneNuberInput.focus();
      //   // this.$refs.firstNameInput.style.border = '1px solid #d93f38';
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else if (!this.pattern.test(this.company_name)) {
      //   this.errMsg = "Please Enter Company Name";
      //   this.errVisible = true;
      //   this.$refs.companyNameINput.focus();
      //   // this.$refs.firstNameInput.style.border = '1px solid #d93f38';
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else {
      // await this.v$.$validate();
      let isValidate =
        !this.v$.industry.$error &&
        !this.v$.job_role.$error &&
        !this.v$.phone_number.$error &&
        !this.v$.company_name.$error;
      if (isValidate) {
        const form_data = {
          first_name: this.firstname,
          last_name: this.lastname,
          email: this.email,
          password: this.password,
          industry: this.industry,
          job_role: this.job_role,
          company_name: this.company_name,
          // company_name_thai: this.company_name,
          // company_size: this.company_size,
          company_website: this.company_website,
          register_code: this.$store.state.register.registerCode,
          data_hosted: "TH",
          device: "mobile",
        };
        try {
          await axios
            .post(`${apiURL}/guest/register`, form_data)
            .then((response) => {
              console.log("response", response);
              if (response.status === 200) {
                // this.hideStep(() => {
                //   // this.$ref.register.className = "close";
                //   setTimeout(() => {
                //     this.showFinal = true;
                //   }, 1000);
                // });
                // this.token = response.data.access_token;
                // this.showStep3();
                this.$toast.success("Success");
                this.$router.push('/');
              }
            });
        } catch (err) {
          this.$toast.error(err.response.data.message);
        }
      } else {
        this.validationStatus = false;
      }
    },
    checkPassword() {
      this.password_length = this.password.length;
      //eslint-disable-next-line
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

      if (this.password_length >= 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }

      // this.contains_number = /\d/.test(this.password);
      // this.contains_lowercase = /[a-z]/.test(this.password);
      // this.contains_uppercase = /[A-Z]/.test(this.password);
      // this.contains_special_character = format.test(this.password);
      this.contains_text = /[a-zA-Z]/.test(this.password)

      if (
        this.contains_eight_characters &&
        this.contains_text
      ) {
        this.valid_password = true;
        this.oninput_password = false;
      } else {
        this.valid_password = false;
        this.oninput_password = true;
      }
    },
    checkConfirmPassword() {
      if (this.password) {
        if (this.password === this.confirmPassword) {
          this.confirm_password = true;
        } else {
          this.confirm_password = false;
        }
      } else {
        this.confirm_password = false;
      }
    },
    // onSignInSuccess(googleUser) {
    //   // `googleUser` is the GoogleUser object that represents the just-signed-in user.
    //   // See https://developers.google.com/identity/sign-in/web/reference#users
    //   const profile = googleUser.getBasicProfile(); // etc etc
    // },
    onSignInError(error) {
      // `error` contains any error occurred.
      console.log("OH NOES", error);
    },
    termModalClick() {
      this.$bvModal.show("modal-term");
    },
    privacyClick() {
      this.$bvModal.show("modal-privacy");
    },
    async checkFirstStep() {
      // if (!this.pattern.test(this.firstname)) {
      //   this.errMsg = "Please Enter Firstname";
      //   this.errVisible = true;
      //   this.$refs.firstNameInput.focus();
      //   // this.$refs.firstNameInput.style.border = '1px solid #d93f38';
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else if (!this.pattern.test(this.lastname)) {
      //   this.errMsg = "Please Enter Lastname";
      //   this.errVisible = true;
      //   this.$refs.lastNameInput.focus();
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else if (!this.emailPattern.test(this.email)) {
      //   this.errMsg = "Please Enter correct Email format";
      //   this.errVisible = true;
      //   this.$refs.emailInput.focus();
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else if (!this.pattern.test(this.password) || !this.valid_password) {
      //   this.errMsg = "Please Enter Password";
      //   this.errVisible = true;
      //   this.$refs.passwordInput.focus();
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else if (
      //   !this.pattern.test(this.confirmPassword) ||
      //   !this.confirm_password
      // ) {
      //   this.errMsg = "Please Enter Confirm Password";
      //   this.errVisible = true;
      //   this.$refs.confirmPasswordInput.focus();
      //   setTimeout(() => {
      //     this.errVisible = false;
      //   }, 5000);
      // } else {

      await this.v$.$validate();
      let isValidate =
        !this.v$.firstname.$error &&
        !this.v$.lastname.$error &&
        !this.v$.email.$error &&
        !this.v$.password.$error &&
        !this.v$.confirmPassword.$error;
      if (isValidate) {
        axios
          .get(`${apiURL}/guest/exist_email?email=` + this.email)
          .then((response) => {
            console.log(response);
            if (response.data.code == 200) {
              const _data = {
                name: this.firstname,
                lastname: this.lastname,
                email: this.email,
                password: this.password,
              };
              this.$store.dispatch("register/setFormNameRegister", _data);
              this.showStep2();
            }
          })
          .catch((err) => {
            if (err.response.data.code == 1004) {
              this.errMsg = "This email already exists.";
              this.errVisible = true;
              this.$refs.emailInput.focus();
              setTimeout(() => {
                this.errVisible = false;
              }, 5000);
            }
          });
      } else {
        this.validationStatus = false;
      }
    },
    setStep() {
      console.log(this.position);
      this.inputLabel = this.registerSteps[this.position].label;
      this.inputType = this.registerSteps[this.position].type;
      this.inputValue = this.registerSteps[this.position].value;
      this.topLabel = this.registerSteps[this.position].top;
      if (this.postion === 0) {
        this.topLabel = "Nice to meet you " + this.firstname;
      }
      this.$refs.registerinput.focus();
      this.showStep();
    },
    showStep3() {
      this.firstStepContainer = false;
      this.step2Status = false;
      this.stepSendEmail = true;
    },
    showStep2() {
      this.firstStepContainer = false;
      this.step2Status = true;
    },
    setFirstStep() {
      this.inputValue = this.username;
      this.showFirstStep();
    },
    showFirstStep() {
      this.inputValue = this.username;
      setTimeout(() => {
        this.firstStepContainer = true;
      }, 100);
    },
    showStep() {
      // console.log(this.firstname);
      this.firstStepContainer = false;
      // this.setStep();
      setTimeout(() => {
        this.showContainer = true;
      }, 100);
    },
    hideStep(callback) {
      this.showContainer = false;
      setTimeout(callback, 100);
    },
    previousStep() {
      this.position -= 1;
      this.$ref.register.className = "";
      this.hideStep(this.setStep);
      this.setProgress();
    },
    checkStep() {
      if (!this.registerSteps[this.position].pattern.test(this.inputValue)) {
        this.$ref.register.classList.add("wrong");
        this.$ref.register.classList.add("wronganimation");
        setTimeout(() => {
          this.$ref.register.classList.remove("wronganimation");
        }, 500);
        // this.$refs.registerinput.focus();
      } else {
        this.$ref.register.className = "";
        this.$ref.register.classList.add("okanimation");
        setTimeout(() => {
          this.$ref.register.classList.remove("okanimation");
        }, 200);
        this.registerSteps[this.position].value = this.inputValue;
        this.position += 1;
        if (this.registerSteps[this.position]) {
          this.hideStep(this.setStep);
        } else {
          axios
            .post("https://api.build3.tech/api/v1/guest/register", {
              name: this.firstname,
              surname: this.lastname,
              email: this.email,
              password: this.password,
              industry: this.industry,
              job_role: this.job_role,
              company_name: this.company_name,
              // company_size: this.company_size,
              company_website: this.company_website,
              register_code: this.$store.state.register.registerCode,
              data_hosted: "TH",
            })
            .then((response) => {
              if (response) {
                this.hideStep(() => {
                  this.$ref.register.className = "close";
                  setTimeout(() => {
                    this.showFinal = true;
                  }, 1000);
                });
                this.token = response.data.access_token;
              }
            });
        }
      }
      this.setProgress();
    },
    resendEmail() {
      this.loading = true;
      axios
        .post(
          `${apiURL}/user/send_verify`,
          {
            name: this.firstname,
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          }
        )
        .then((response) => {
          this.loading = false;
          console.log(response);
        })
        .catch(() => (this.loading = false));
    },
    setProgress() {
      this.progress = (this.position / this.registerSteps.length) * 100 + "%";
    },
    signin() {
      this.$router.push({ name: "Signin" });
    },
  },
  mounted() {
    // document.getElementById("register");
    this.setFirstStep();
  },
};
</script>
<style lang="scss" scoped>
.bg-form {
  background-color: #212E3E;
  background-image: url("../assets/bg-form-mobile.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}

.text-check-box {
  color: var(--text-subtitle, #51646B);
  font-family: "Noto Sans Thai", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  /* 175% */
}

.text-herder-create-acount {
  font-size: 40px;
  font-family: "Noto Sans Thai", sans-serif;
  color: #fff;
  font-weight: 700;
}

.label-text {
  color: #265054;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 171.429% */
}

.container {
  position: relative;
  font-family: "Noto Sans", sans-serif;
  font-size: 1rem;
  color: #333;
  width: 100%;
  min-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;

  // background: radial-gradient(#009345, #106B4E);
  #progress {
    position: absolute;
    top: 0;
    left: 0;
    width: 0%;
    height: 1vh;
    background-color: #51646b;
    transition: width 0.8s ease-in-out;
  }
}

h1 {
  position: absolute;
  width: max-content;
  font-size: 2rem;
  color: #51646b;
  opacity: 0;
  transition: 0.8s ease-in-out;

  &.show-final {
    opacity: 1;
  }
}

h2 {
  font-weight: bold;
  color: #51646b;
}

#register {
  position: relative;
  // width: 480px;
  // height: 80px;
  padding: 10px;
  // background-color: #fff;
  // box-shadow: 0 15px 30px rgba(0, 0, 0, .2),
  //   0 10px 10px rgba(0, 0, 0, .2);

  &.close {
    width: 0;
    padding: 10px 0;
    overflow: hidden;
    transition: 0.8s ease-in-out;
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.2);
  }
}

.errMsg {
  transition: 0.8s ease-in-out;
  font-size: 16px;
  font-weight: bold;
}

.previousButton {
  position: absolute;
  left: 30px;
  top: 12px;
  font-size: 1rem;
  color: #9e9e9e;
  cursor: pointer;
  z-index: 20;

  &:hover {
    color: #51646b;
  }
}

.forwardButton {
  position: absolute;
  top: 30px;
  right: 20px;
  font-size: 3rem;
  color: #51646b;
  cursor: pointer;
  z-index: 20;

  &:hover {
    color: #51646b;
  }
}

.wrong .forwardButton {
  color: #d93f38;
}

.close .forwardButton,
.close .previousButton {
  color: #fff;
}

#inputContainer {
  position: relative;
  padding: 30px 20px 20px 20px;
  margin-right: 60px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  input {
    position: relative;
    width: 100%;
    font-size: 1.35rem;
    font-weight: bold;
    outline: 0;
    background: transparent;
    box-shadow: none;
    border: none;

    &:valid+#inputLabel {
      top: 3px;
      left: 42px;
      font-size: 0.7rem;
      font-weight: normal;
      color: #999;
    }
  }
}

#firstStep {
  position: relative;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  // input:valid {
  //   border: 1px solid #ebeeef;
  // }
  input {
    position: relative;
    width: 100%;
    font-size: 0.85rem;
    font-weight: bold;
    outline: 0;
    padding: 10px;
    // background: transparent;
    box-shadow: none;
    // margin-bottom: 15px;
    // border: none;
    border: 1px solid #ebeeef;
    border-radius: 8px;
    margin-right: 15px;

    &:valid+#inputLabel {
      top: 3px;
      left: 42px;
      font-size: 0.7rem;
      font-weight: normal;
      color: #999;
    }
  }
}

#inputLabel {
  position: absolute;
  top: 32px;
  left: 20px;
  font-size: 1.35rem;
  font-weight: bold;
  pointer-events: none;
  transition: 0.2s ease-in-out;
}

.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
}

#inputProgress {
  width: 0%;
  border-bottom: 6px solid #51646b;
  transition: width 0.6s ease-in-out;
}

.wrong #inputProgress {
  border-color: #d93f38;
}

.btn-signup {
  font-size: 10px;
  padding: 5px;
  width: 100%;
  text-align: center;
  background-color: #fff;
  color: #265054;
  height: 50px;
  border-radius: 10px;
  text-transform: uppercase;
  border: 1px solid #265054;
}

.showContainer {
  opacity: 1 !important;

  #inputProgress {
    width: 100%;
  }
}

.wronganimation {
  animation: 0.5s linear 0s 1 wrong-animation;
}

.okanimation {
  animation: 0.2s linear 0s 1 ok-animation;
}

@keyframes wrong-animation {
  0% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(-20px);
  }

  40% {
    transform: translateX(20px);
  }

  60% {
    transform: translateX(-20px);
  }

  80% {
    transform: translateX(20px);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes ok-animation {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(0);
  }
}

/* Password Input --------- */

.input_container {
  position: relative;
  padding: 30px;
  // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  // border-radius: 6px;
  background: #fff;
}

.right-container {
  position: relative;
  font-family: "Noto Sans", sans-serif;
  display: block;
  //   justify-content: center;
  //   align-items: center;
  margin: auto;
  padding-left: 5%;
}

input[type="password"] {
  line-height: 1.5;
  display: block;
  color: rgba(136, 152, 170, 1);
  font-weight: 300;
  width: 100%;
  height: calc(2.75rem + 2px);
  padding: 0.625rem 0.75rem;
  border-radius: 0.25rem;
  background-color: #fff;
  transition: border-color 0.4s ease;
  border: 1px solid #cad1d7;
  outline: 0;
}

input[type="password"]:focus {
  border-color: rgba(50, 151, 211, 0.45);
}

/* Checkmark & Strikethrough --------- */
.is_valid {
  color: rgba(77, 202, 66, 0.8);
}

.is_valid:before {
  width: 100%;
}

.checkmark_container {
  border-radius: 50%;
  position: absolute;
  top: 27px;
  right: 43%;
  background: #2ecc71;
  width: 50px;
  height: 50px;
  visibility: hidden;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.4s ease;
}

.login-choice span {
  color: #5b6987;
  display: -ms-grid;
  display: grid;
  font-size: 16px;
  width: 100%;
  line-height: 40px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  -ms-grid-columns: minmax(20px, 1fr) auto minmax(20px, 1fr);
  grid-template-columns: minmax(20px, 1fr) auto minmax(20px, 1fr);
  grid-gap: 19px;
}

.login-choice span:after,
.login-choice span:before {
  content: "";
  border-top: 1px solid #e5e8ed;
}

.show_checkmark {
  visibility: visible;
  opacity: 1;
}

.checkmark {
  width: 100%;
  height: 100%;
  fill: none;
  stroke: white;
  stroke-width: 15;
  stroke-linecap: round;
  stroke-dasharray: 180;
  stroke-dashoffset: 180;
}

.checked {
  animation: draw 0.5s ease forwards;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
